import type { FormItemWrapperProps } from './typings'

export const splitPropsBetweenFormInputAndFormItemWrapper = <D = Record<string, unknown>>(
  props: FormItemWrapperProps & D
) => {
  const {
    label,
    hint,
    ariaIds,
    secondary,
    withAsterisk,
    errorMessage,
    formItemProps,
    notClickableLabel,
    ...formInputProps
  } = props
  return {
    formInputProps,
    formItemWrapperProps: {
      label,
      hint,
      ariaIds,
      secondary,
      withAsterisk,
      errorMessage,
      formItemProps,
      notClickableLabel,
      formInputProps,
    },
  }
}
